const SUPPORTED_FIAT_CURRENCIES = [
    "USD",
    "CAD",
    "GBP",
    "EUR",
    "JPY",
    "AUD",
    "NZD",
];
export function getFiatSymbol(showBalanceInFiat) {
    switch (showBalanceInFiat) {
        case "USD":
            return "$";
        case "CAD":
            return "$";
        case "GBP":
            return "£";
        case "EUR":
            return "€";
        case "JPY":
            return "¥";
        case "AUD":
            return "$";
        case "NZD":
            return "$";
        default:
            return "$";
    }
}
//# sourceMappingURL=type.js.map